const ONE_HUNDRED = 100;

export { ONE_HUNDRED };
